(() => {
  if (customElements.get('product-description-accordion')) {
    return;
  }

  class ProductDescriptionAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') {
        return;
      }

      const sectionHeadings = Array.from(this.children).filter((element) =>
        ['H2', 'H3', 'H4'].includes(element.tagName)
      );

      if (sectionHeadings.length === 0) {
        return;
      }

      sectionHeadings.forEach((heading) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const title = document.createElement('span');
        const icon = document.createElement('span');
        const panel = document.createElement('div');

        details.className = 'product-description-accordion__item';
        summary.className = 'product-description-accordion__summary';
        title.className = 'product-description-accordion__title';
        icon.className = 'product-description-accordion__icon';
        icon.setAttribute('aria-hidden', 'true');
        panel.className = 'product-description-accordion__panel';

        while (heading.firstChild) {
          title.appendChild(heading.firstChild);
        }

        summary.append(title, icon);
        details.append(summary, panel);
        heading.before(details);

        let nextNode = heading.nextSibling;
        while (nextNode) {
          const nodeToMove = nextNode;
          const isNextHeading =
            nodeToMove.nodeType === Node.ELEMENT_NODE &&
            ['H2', 'H3', 'H4'].includes(nodeToMove.tagName);

          if (isNextHeading) {
            break;
          }

          nextNode = nodeToMove.nextSibling;
          panel.appendChild(nodeToMove);
        }

        heading.remove();
      });

      this.dataset.enhanced = 'true';
    }
  }

  customElements.define(
    'product-description-accordion',
    ProductDescriptionAccordion
  );
})();
